import { cachePreloadUrls } from 'owa-localize-internal';
import { setLocale } from 'owa-localize';
import { initializeOwaTimeFormatTranslations } from 'owa-timeformat-localization';
import { initializeOwaDateTimeTranslations } from 'owa-datetime-localization';
import { getVariantEnvironment } from 'owa-metatags';

// There is a limited number of languages that are deployed in the AGALL environment
const enabledAgallLanguages = ['en'];

export function initializeOwaLocalization(culture: string): Promise<void> {
    const env = getVariantEnvironment();
    const isAirGap = env == 'AG08' || env == 'AG09';
    if (isAirGap && enabledAgallLanguages.indexOf(culture) == -1) {
        // we default to english if the language is not available
        culture = 'en';
    }
    /**
     * Any shared packages that are used in boot should have their
     * localization initialized here. Any shared packages *not* used in boot
     * should have their localization initialized by the LazyModule which loads
     * the shared package
     */
    initializeOwaTimeFormatTranslations();
    initializeOwaDateTimeTranslations();
    const promise = setLocale(culture);
    cachePreloadUrls();
    return promise;
}
